<template>
    <div class="order-page">
        <!-- 顶部标题栏（对应 uniapp 原生导航栏「完善订单信息」） -->
        <div class="nav-bar">
            <span class="nav-back" @click="goBack">‹</span>
            <span class="nav-title">完善订单信息</span>
        </div>

        <!-- 表单区域 -->
        <div class="form-section">
            <span class="section-title">咨询人</span>

            <!-- 姓名 -->
            <div class="form-item">
                <span class="label">
                    <span class="required">*</span>
                    姓名
                </span>
                <input class="form-input" type="text" v-model="form.name" placeholder="填写姓名" />
            </div>

            <!-- 手机号（tel 保证 maxlength 生效且移动端唤起数字键盘） -->
            <div class="form-item">
                <span class="label">
                    <span class="required">*</span>
                    手机号
                </span>
                <input
                    class="form-input"
                    type="tel"
                    maxlength="11"
                    v-model="form.phone"
                    placeholder="填写联系方式"
                />
            </div>

            <!-- 性别 -->
            <div class="form-item">
                <span class="label">
                    <span class="required" style="color: transparent">*</span>
                    性别
                </span>
                <div class="sex-group">
                    <div
                        :class="['sex-btn', form.sex === 1 ? 'sex-active' : '']"
                        @click="form.sex = 1"
                    >
                        男
                    </div>
                    <div
                        :class="['sex-btn', form.sex === 2 ? 'sex-active' : '']"
                        @click="form.sex = 2"
                    >
                        女
                    </div>
                </div>
            </div>

            <!-- 咨询方式 -->
            <div class="zxfs-section">
                <span class="zxfs-title">咨询方式</span>
                <div class="zxfs-group">
                    <div class="zxfs-btn zxfs-active">语音咨询</div>
                </div>
            </div>

            <!-- 咨询时长 -->
            <div class="time-section">
                <span class="time-title">咨询时长</span>
                <div class="time-group">
                    <div class="time-btn time-active">1小时</div>
                </div>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="footer-bar">
            <div class="submit-btn" @click="handleSubmit">
                <span class="btn-text">立即预约</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                name: '', // 咨询人姓名
                phone: '', // 咨询人手机号
                sex: 1, // 性别：1-男，2-女
            },
        };
    },
    methods: {
        // 返回上一页（无历史记录时兜底回咨询页）
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.replace('/zixun');
            }
        },

        // 提交预约
        handleSubmit() {
            if (!this.form.name.trim()) {
                this.$toast('请填写姓名');
                return;
            }
            if (!/^1\d{10}$/.test(this.form.phone)) {
                this.$toast('请填写正确的手机号');
                return;
            }
            // 预约成功弹窗，确认后返回上一页
            this.$dialog
                .alert({
                    title: '预约成功',
                    message: '您的咨询预约已提交，我们将尽快与您联系确认时间。',
                    confirmButtonText: '好的',
                })
                .then(() => {
                    this.$router.back();
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.order-page {
    min-height: 100vh;
    background: #f5f5f5;
    padding-bottom: 180rpx;
}

/* 顶部标题栏（对应 uniapp 原生导航栏样式：#F5F9FE 背景黑字，滚动时固定顶部） */
.nav-bar {
    position: sticky; // 滚动时固定在顶部
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88rpx;
    background: #f5f9fe;
}

.nav-back {
    position: absolute;
    left: 24rpx;
    font-size: 48rpx;
    color: #000;
    line-height: 1;
    padding: 0 16rpx;
    cursor: pointer;
}

.nav-title {
    font-size: 32rpx;
    font-weight: 500;
    color: #000;
}

.form-section {
    background: #fff;
    margin: 20rpx 30rpx;
    border-radius: 16rpx;
    padding: 30rpx;
}

.section-title {
    font-size: 32rpx;
    font-weight: 600;
    color: #333;
    margin-bottom: 20rpx;
    display: block;
}

/* 表单项 */
.form-item {
    position: relative;
    height: 90rpx;
    border-bottom: 1rpx solid #f2f2f2;
    display: flex;
    align-items: center;
}

.label {
    position: absolute;
    left: 0;
    font-size: 24rpx;
    color: #333;
    z-index: 1;
}

.required {
    color: #c32424;
    margin-right: 4rpx;
}

// 输入框（H5 需重置原生样式）
.form-input {
    flex: 1;
    padding-left: 130rpx;
    font-size: 26rpx;
    height: 90rpx;
    border: none;
    outline: none;
    background: transparent;
    box-sizing: border-box;
}

// 占位符样式（对应小程序的 placeholder-class）
.form-input::placeholder {
    color: #ccc;
    font-size: 24rpx;
}

/* 性别选择 */
.sex-group {
    position: absolute;
    right: 0;
    display: flex;
}

.sex-btn {
    width: 116rpx;
    height: 60rpx;
    background: #f1f1f1;
    border-radius: 6rpx;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rpx;
    color: #999;
    margin-left: 20rpx;
    cursor: pointer;

    &:active {
        opacity: 0.85;
    }
}

.sex-active {
    background: #363940 !important;
    color: #fff !important;
}

/* 咨询方式 */
.zxfs-section {
    margin-top: 40rpx;
}

.zxfs-title {
    font-size: 32rpx;
    font-weight: 500;
    color: #000;
    display: block;
    margin-bottom: 28rpx;
}

.zxfs-group {
    display: flex;
    flex-wrap: wrap;
}

.zxfs-btn {
    width: 155rpx;
    height: 74rpx;
    background: #f1f1f1;
    border-radius: 6rpx;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rpx;
    color: #999;
    margin-right: 20rpx;
    margin-bottom: 20rpx;

    &:nth-child(3n) {
        margin-right: 0;
    }

    &:active {
        opacity: 0.85;
    }
}

.zxfs-active {
    background: #363940 !important;
    color: #fff !important;
}

/* 咨询时长 */
.time-section {
    margin-top: 40rpx;
}

.time-title {
    font-size: 32rpx;
    font-weight: 500;
    color: #000;
    display: block;
    margin-bottom: 28rpx;
}

.time-group {
    display: flex;
}

.time-btn {
    width: 208rpx;
    height: 74rpx;
    background: #f1f1f1;
    border-radius: 6rpx;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rpx;
    color: #999;
    margin-right: 34rpx;
}

.time-active {
    background: #363940 !important;
    color: #fff !important;
}

/* 底部按钮 */
.footer-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 20rpx 30rpx;
    padding-bottom: calc(20rpx + env(safe-area-inset-bottom));
    display: flex;
    justify-content: center;
    z-index: 10;
}

.submit-btn {
    width: 90%;
    height: 90rpx;
    background: #363942;
    border-radius: 10rpx;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:active {
        opacity: 0.85;
    }
}

.btn-text {
    font-size: 32rpx;
    font-weight: 500;
    color: #e6d1ad;
}
</style>
